import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SalesEntityService } from 'app/layout/sales-entity/sales-entity-service/sales-entity-service';
import { BindingContext } from 'app/shared/models/BindingContext';
import { SalesEntityModelList, SalesEntityListInquiry, SystemModel, Institution, SalesRep, Chain, SalesEntityModel, AlliancePartner, Association, SalesEntityBoardingHierarchyNew, SalesEntityContact, SalesEntityAddress } from 'app/shared/models/EvoSalesPortalModel';
import { HttpErrorResponse } from '@angular/common/http';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { FormsValidationService } from '../../../../../../shared/services/formsValidation.service';
import { FormatService } from 'app/shared/services/format.service';
import { UserAccessService } from '../../../../../../shared/services/user-access.service';
import { EvoPatternValidator } from 'app/shared/validators/evo-pattern-validator.directive';

@Component({
    selector: 'se-address-editor-modal',
    styleUrls: ['se-address-editor.scss'],
    templateUrl: 'se-address-editor.html',
})
export class SalesEntityAddressEditorComponent {
    bindingContext: BindingContext = new BindingContext();
    private formValidatorSub: ISubscription;
    seForm: FormGroup;
    private subscription: ISubscription;
    @Input() Address: SalesEntityAddress;
    @Input() salesEntityID: number;
    saving: boolean = false;
    ActionType: string = "Edit";
    public isDefault: boolean = false;
    private _formValid: boolean;
    public set FormValid(input: boolean) {
        this._formValid = input;
    }
    public get FormValid(): boolean {
        return this._formValid;
    }
    public get States() {
        //console.log("State Data: ", this.seSvc.StateDropdownData());
        return this.seSvc.StateDropdownData();
    }

    constructor(public activeModal: NgbActiveModal,
        private seSvc: SalesEntityService,
        private formSvc: FormsValidationService,
        private formatService: FormatService,
        private accSvc: UserAccessService) {
        this.bindingContext.isBusy = false;
        this.CreateForm();
    }

    ngOnInit() {
        //Inputs are loaded at this lifecycle event
        if (this.Address) {
            this.ActionType = "Edit";
            this.formSvc.BindDataToFormGroup(this.Address, this.seForm);
            console.log("AddressPassedIn:", this.Address);
        } else {
            this.ActionType = "Add";
        }
    }

    ngOnDestroy() {
        if (this.subscription) { this.subscription.unsubscribe(); }
        if (this.formValidatorSub) { this.formValidatorSub.unsubscribe(); }
    }

    /**
    * Builds the formGroup for this input
    * @ Subscribes to form changes and binds the validity to the FormValid property
    */
    CreateForm() {
        //Create the form and it's validators
        this.seForm = new FormGroup({
            Label: new FormControl('', [Validators.required]),
            FirstName: new FormControl('', [Validators.required]),
            LastName: new FormControl('', [Validators.required]),
            AddressTypeID: new FormControl('', [Validators.required]),
            Department: new FormControl('', [Validators.required]),
            AddressLine1: new FormControl('', [Validators.required]),
            AddressLine2: new FormControl(''),
            City: new FormControl('', [Validators.required]),
            State: new FormControl('', [Validators.required]),
            Zip: new FormControl('', [Validators.required, EvoPatternValidator(this.formSvc.ZipRegex,this.formSvc.ZipErrorMsg)]),
        });
        //Subscribe to form change events and validate dirty fields
        this.formValidatorSub = this.seForm.valueChanges.subscribe((data) => {
            //console.log(this.seForm.controls);
            this.FormValid = this.formSvc.formIsValid(this.seForm, true);
        });
    }

	/**
	 * Formats a value into a phone number and resets the phone field to that value
	 * @param event 
	 * @param fieldName 
	 */
    public formatZip(event: any, fieldName: string) {
        var tag = event.target ? event.target : event.srcElement;
        var formattedNumber = this.formatService.formatZip(tag.value);
        (<FormControl> this.seForm.controls[fieldName]).setValue(formattedNumber);
    }

    onSubmit() {
        this.saving = true;
        let tempEntity = new SalesEntityAddress();
        this.formSvc.BindFormGroupToData(this.seForm, tempEntity, true);
        tempEntity.SalesEntityID = this.salesEntityID;
        if (this.Address) {
            //We were provided a contact as input and are editing.
            //Save as existing contact
            tempEntity.AddressID = this.Address.AddressID;
            console.log('SUBMISSION:', tempEntity);
            this.seSvc.UpdateAddress(tempEntity).toPromise().then(resp => {
                //this.accSvc.Securable_RefreshSectionCache(undefined, undefined, this.contact.SalesEntityID,);
                this.accSvc.GetSecurableObjectByName("SALES-ENTITY|ADDRESS|LABEL", undefined, this.salesEntityID, undefined, true).then(innerResp => {
                    this.accSvc.Securable_RefreshSectionCache("SALES-ENTITY", undefined, this.salesEntityID, undefined, this.Address.AddressID, innerResp.ObjectSecurableID);
                    this.saving = false;
                    this.activeModal.close(true);
                });
            }).catch((resp: HttpErrorResponse) => {
                this.bindingContext.endGet();
                this.saving = false;
                alert('There was an error saving address, please try again. Contact support if this problem persists.');
            });
        }
        else {
            //No provided contact, insert brand new
            tempEntity.AddressTypeID = 'M';
            console.log('SUBMISSION:', tempEntity);
            this.seSvc.InsertAddress(tempEntity).toPromise().then(resp => {
                this.saving = false;
                this.activeModal.close(true);
            }).catch((resp: HttpErrorResponse) => {
                this.bindingContext.endGet();
                this.saving = false;
                alert('There was an error saving address, please try again. Contact support if this problem persists.');
            });
        }
    }


    public canSave() {
        if (this.Address) { //EDITING
            if (!this.FormValid || !this.seForm.dirty) {
                //Only validate dirty fields, 
                //but don't allow submission unless 1 or more is dirty
                return false;
            } else {
                //The form is valid, and dirty
                return true;
            }
        } else { //ADDING
            if (!this.seForm.dirty || !this.seForm.valid) {
                //The whole form dirty or not must be valid
                //And you can't submit anyway unless it's dirty
                return false;
            } else {
                //The form is dirty AND not valid
                return true;
            }
        }
    }
}
